import BaseComponent from 'scripts/BaseComponent.js';

export default class FilterClear extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      clearBtn: '.js-clearFilterBtn',
    };

    this.dom = {
      $component: component,
      $clearBtn: this.$get(this.refs.clearBtn),
    };

    this.state = {
      clearFilterEvent: 'clearfilter',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setClick(dom.$clearBtn, this.clearFilters);
  }

  clearFilters() {
    const { state: { clearFilterEvent } } = this;
    this.dispatch(clearFilterEvent);
  }
}
